import React from 'react'
import { animated } from 'react-spring/renderprops.cjs'

import { AcornsIcon } from '@acorns/icons'
import { compose, withHandlers } from 'recompose'
import styled from 'styled-components'

import { theme } from '../../theme'

interface IProps {
  fillHeight?: boolean
  height?: number
  styles?: React.CSSProperties
  index: number
  name: string
  onRemove: (event: { index: number }) => void
  failed?: boolean
}

interface IHandlerProps {
  handleClick: (event: React.MouseEvent<SVGElement, MouseEvent>) => void
}

type MergedProps = IProps & IHandlerProps

const Container = styled(animated.div)<{
  height?: string
  fillHeight?: boolean
}>`
  align-items: center;
  border-radius: ${theme('styles.borderRadius')};
  border: solid 1px #eeeded;
  display: flex;
  height: ${(props) => props.height};
  padding: 0 20px;
  justify-content: space-between;
  margin-bottom: 20px;

  ${(props) => props.fillHeight && 'height: 100%;'};
`

const Label = styled.div`
  align-items: center;
  color: ${theme('colors.slate')};
  display: flex;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.4px;
  line-height: 14px;
`

const ErrorLabel = styled.div`
  align-items: center;
  color: ${theme('colors.red')};
  display: flex;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.4px;
  line-height: 14px;
  padding-left: 14px;
`

const CloseIcon = styled(AcornsIcon)`
  cursor: pointer;
`

const IconContainer = styled.div`
  margin-right: 14px;
`

const enhance = compose<MergedProps, IProps>(
  withHandlers<IProps, Pick<IHandlerProps, 'handleClick'>>({
    handleClick:
      ({ index, onRemove }) =>
      () => {
        onRemove({ index })
      },
  }),
)

export const DocumentItem: React.FC<MergedProps> = (props) => (
  <Container
    fillHeight={props.fillHeight}
    style={props.styles}
    data-testid={`document_upload_item_${props.name}`}
  >
    <Label>
      <IconContainer>
        <AcornsIcon
          icon={AcornsIcon.Icon.UtilityDocuments}
          width="20px"
          height="20px"
        />
      </IconContainer>
      {props.name}
      {props.failed && <ErrorLabel>{` - Failed`}</ErrorLabel>}
    </Label>
    <CloseIcon
      icon={AcornsIcon.Icon.CloseXIcon}
      onClick={props.handleClick}
      height="20px"
      width="20px"
    />
  </Container>
)

export default enhance(DocumentItem)
